export default __webpack_public_path__ + "static/media/black_royal_queen.fa0386ec.png";